const featureToggles = {
  DocuSign: false,
  enableNewBlog: true,
  isNotificationEnabled: false
}

export default featureToggles
